import LocalStore from "../../../utilities/local-store-manager";
import BaseProxy from "../../base-proxy";

/**
 * @class SleekSurveyProxy
 * @description Class used for communicating with resource allocation API.
 * @author Jay Turla
 * @version 1.0
 * @since May 25, 2023
 */
export default class SleekSurveyProxy {
  /**
   * @async
   * @function execute
   * @param body - Input parameter instance.
   */
  async submitSurveyRatings(body) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getSleekSurveyUrl();
    let endpointUrl = `${backendUrl}/rating`;
    let localStore = new LocalStore();
    let authToken = localStore.getToken();
    return await baseProxy.postAuthenticatedData(endpointUrl, authToken, body);
  }

  async getSurveyByVersionAndKey(path) {
    let baseProxy = new BaseProxy();
    const backendUrl = await baseProxy.getSleekSurveyUrl();
    const endpointUrl = `${backendUrl}/${path}`;
    let localStore = new LocalStore();
    let authToken = localStore.getToken();
    return await baseProxy.getAuthenticatedData(endpointUrl, authToken);
  }
}
